__turbopack_context__.v({
  "container": "IframeBlock-module__PUb0VW__container",
});
